import { apiClient } from './apiClient';
import type { StatisticsSummaryResponse, StatisticsQuery } from '../types/adminStatistics';

export const adminStatisticsService = {
  async getSummary(query: StatisticsQuery): Promise<StatisticsSummaryResponse> {
    const params = new URLSearchParams();
    params.set('from', query.from);
    params.set('to', query.to);
    if (query.clientIds?.length) params.set('client_ids', query.clientIds.join(','));
    if (query.domainIds?.length) params.set('domain_ids', query.domainIds.join(','));
    if (query.granularity) params.set('granularity', query.granularity);
    if (query.includeSystem !== undefined) params.set('include_system', String(query.includeSystem));

    const { data } = await apiClient.get<StatisticsSummaryResponse>(
      `/admin/statistics/summary?${params.toString()}`,
    );
    return data;
  },
};
